type IsOfferExpiredOptions = {
  useServerTime?: boolean;
  serverTime?: Date | string | null;
};

export default function isOfferExpired(
  ended_at: Date,
  now: Date,
  options: IsOfferExpiredOptions = {},
): boolean {
  const end = new Date(ended_at);
  const referenceNow =
    options.useServerTime && options.serverTime
      ? new Date(options.serverTime)
      : now;

  // Offer is expired if end datetime is before now
  const isOfferExpired = end.getTime() < referenceNow.getTime();
  return isOfferExpired;
}
